module.exports = __webpack_public_path__ + "static/img/2.6b710ec.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/4/eng/2.png
// module id = v0IX
// module chunks = 0